import { useMsal } from '@azure/msal-react';
import { KeyboardArrowDown } from '@mui/icons-material';
import { Button, ButtonBase, CircularProgress, Menu, MenuItem } from '@mui/material';
import { viewAnalytics } from 'api';
import React from 'react';
import { testing_getForce401, testing_setForce401 } from './api';

/**
 * Renders a sign-out button
 */
export const SignOutButton = () => {
  const { instance } = useMsal();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isViewingAnalytics, setIsViewingAnalytics] = React.useState(false);
  const [testLabel, setTestLabel] = React.useState('Enable Force 401 Unauthorized');

  const onMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const onMenuClose = () => {
    setAnchorEl(null);
  };

  const onClose = () => {
    if (window.confirm('Are you sure you would like to exit?')) {
      sessionStorage.clear();
      window.history.go(-(window.history.length - 1));
    }
  };

  const onLogout = logoutType => {
    if (logoutType === 'popup') {
      instance.logoutPopup({
        postLogoutRedirectUri: '/',
        mainWindowRedirectUri: '/'
      });
    } else if (logoutType === 'redirect') {
      instance.logoutRedirect({
        postLogoutRedirectUri: '/'
      });
    }
  };

  return (
    <div>
      <Button disabled={isViewingAnalytics} onClick={onClose} style={{ color: '#fff' }}>
        EXIT
      </Button>

      <ButtonBase
        disabled={isViewingAnalytics}
        variant='text'
        onClick={onMenuOpen}
        sx={{
          color: '#fff',
          minHeight: 36.49
        }}
      >
        <KeyboardArrowDown />
      </ButtonBase>

      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        onClose={onMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <MenuItem
          disabled={isViewingAnalytics}
          onClick={() => {
            if (window.confirm('Are you sure you would like to logout?')) {
              onLogout('redirect');
            }
          }}
        >
          LOGOUT
        </MenuItem>

        <MenuItem
          disabled={isViewingAnalytics}
          onClick={() => {
            setIsViewingAnalytics(true);
            viewAnalytics().finally(() => {
              setIsViewingAnalytics(false);
            });
          }}
        >
          VIEW ANALYTICS {isViewingAnalytics && <CircularProgress size={20} sx={{ ml: 2 }} />}
        </MenuItem>

        {/* <MenuItem
          onClick={e => {
            const testing_force401 = testing_getForce401();

            if (testing_force401 === false) {
              if (
                window.confirm(
                  '⚠️ TESTING PURPOSES ONLY! ⚠️\n\nEnabling "Force 401 Unauthorized" will exclude your token from all API requests, simulating an invalid token, and resulting in 401 Unauthorized response codes for any requests.'
                )
              ) {
                testing_setForce401(true);
                setTestLabel('Disable Force 401 Unauthorized');
              }
            } else {
              testing_setForce401(false);
              setTestLabel('Enable Force 401 Unauthorized');
            }
          }}
        >
          {testLabel.toUpperCase()}
        </MenuItem> */}
      </Menu>
    </div>
  );
};
